var render = function render(){var _vm=this,_c=_vm._self._c;return (Array.isArray(_vm.treeData) && _vm.treeData.length > 0 && _vm.isShow)?_c('tree',{attrs:{"data":_vm.treeData,"options":{ propertyNames: { text: 'name' }, dnd: false }},on:{"node:dragging:finish":_vm.dragFinish,"node:selected":_vm.onNodeSelected}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }